import domReady from './utils/domReady';

const components = [
	['html', () => import(/* webpackPrefetch: true */'./components/root')],	
	['body', () => import(/* webpackPrefetch: true */'./components/search')],
	['body', () => import(/* webpackPrefetch: true */'./components/videoModal')],
	['body', () => import(/* webpackPrefetch: true */'./components/resources')],
	['[data-slide-replace]', () => import(/* webpackPrefetch: true */'./components/slide-replace')],
	['div[id^="teleport"]', () => import(/* webpackPrefetch: true */'./components/prestige-teleport')],
	['div[nav]', () => import(/* webpackPrefetch: true */'./components/nav-remaster')],
	['form[type]:not([type*="Calc"])', () => import(/* webpackPrefetch: true */'./components/forms')],
	['form[type*="Calc"]', () => import(/* webpackPrefetch: true */'./components/calculatorForms')],
	['comp-accordion', () => import(/* webpackPrefetch: true */'./components/accordion')],
	['comp-dealer > [map]', () => import(/* webpackPrefetch: true */'./components/dealerMap')],
	['comp-dealers', () => import(/* webpackPrefetch: true */'./components/dealers')],
	['comp-expand-blocks', () => import(/* webpackPrefetch: true */'./components/expand-blocks')],
	['comp-faq dl > dt', () => import(/* webpackPrefetch: true */'./components/faq')],
	['comp-filters', () => import(/* webpackPrefetch: true */'./components/filters')],
	['comp-footer-actions', () => import(/* webpackPrefetch: true */'./components/footer-actions')],
	['comp-revealer', () => import(/* webpackPrefetch: true */'./components/revealer')],
	['comp-swipe-card', () => import(/* webpackPrefetch: true */'./components/swipe-card'), true],
	['comp-tabs', () => import(/* webpackPrefetch: true */'./components/tabs')],
	['comp-press', () => import(/* webpackPrefetch: true */'./components/press')],
	['comp-truck-explore', () => import(/* webpackPrefetch: true */'./components/truck-explore')],
	['comp-truck-hero', () => import(/* webpackPrefetch: true */'./components/truck')],
	['comp-truck-hero + [build]', () => import(/* webpackPrefetch: true */'./components/truck-build-anim')],
	['comp-video', () => import(/* webpackPrefetch: true */'./components/videoInline')],
	['[data-react]', () => import(/* webpackPrefect: true */'./components/react/index.jsx')],
	['miles-counter', () => import(/* webpackPrefetch: true */'./components/miles-counter')],
	['comp-highlight', () => import(/* webpackPrefetch: true */'./components/highlight')],
	['take-over', () => import(/* webpackPrefetch: true */'./components/takeover')],
	['body', () => import(/* webpackPrefetch: true */'./components/supertruck')],
	['body', () => import(/* webpackPrefetch: true */'./components/blog-category-filter')],
	['div[comp-accordion]', () => import(/* webpackPrefetch: true */'./components/accordion-solo')],
	['body', () => import(/* webpackPrefetch: true */'./components/alpine/index')],
	['script[type="load-script"]', () => import(/* webpackPrefetch: true */'./utils/loadScripts'), true]
];

domReady.then(() => components.forEach(
	async ([elements, loader, combined]) => {
		const elementList = [...document.querySelectorAll(elements)];

		if (combined && elementList.length > 0) {
			const elementLoader = await loader();
			if (elementLoader.default && typeof elementLoader.default === 'function')
				return await elementLoader.default(elementList);
        }
		
		return elementList.forEach(
			async (element, index) => {
				const l = await loader();
				if (l.default && typeof l.default === 'function')
					l.default(element, index);
            }
		);
	}
));
